import TPager from './pager.vue'

TPager.install = Vue => {
  Vue.component(TPager.name, TPager)
}

export default TPager



// WEBPACK FOOTER //
// ./src/module/pager/index.js